"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clipboard = __importStar(require("clipboard-polyfill/text"));
const react_redux_1 = require("react-redux");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const stateFunctions_1 = require("../../domain/stateFunctions");
const changeSidePanel_1 = require("../../actions/app/changeSidePanel");
const service_1 = __importDefault(require("../../services/userMgmt/service"));
const addParticipants_1 = __importDefault(require("../../actions/chats/addParticipants"));
const SearchBox_1 = __importDefault(require("../shared/SearchBox"));
const u64 = __importStar(require("../../utils/u64Functions"));
const UserListItem_1 = __importDefault(require("../shared/UserListItem"));
const users_1 = require("../../domain/model/users");
const Header_1 = __importDefault(require("./Header"));
const CreateGroupChatIcon_1 = __importDefault(require("../shared/CreateGroupChatIcon"));
const panels_1 = require("../../domain/model/panels");
const PLACEHOLDER_TEXT = "Type a username";
exports.default = react_1.default.memo(AddParticipantsPanel);
function AddParticipantsPanel() {
    const dispatch = react_redux_1.useDispatch();
    const chat = react_redux_1.useSelector((state) => stateFunctions_1.getSelectedChat(state.chatsState));
    const emptyResults = [];
    const [text, setText] = react_1.useState("");
    const [results, setResults] = react_1.useState(emptyResults);
    const [tooltipOpen, setTooltipOpen] = react_1.useState(false);
    const tooltipTimeout = react_1.useRef();
    const clearInput = () => setText("");
    const textBoxRef = react_1.useRef(null);
    function handleInputChange(text) {
        setText(text);
        if (text.length > 0) {
            const request = {
                search_term: text,
                max_results: 20
            };
            service_1.default.searchUsers(request).then(response => {
                if (text.length > 0) {
                    setResults(response.users);
                }
            });
        }
        else {
            setResults(emptyResults);
        }
    }
    function handleCopyCodeButtonClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (tooltipTimeout.current) {
                clearTimeout(tooltipTimeout.current);
            }
            yield clipboard.writeText(u64.toHex(chat.chatId));
            setTooltipOpen(true);
            tooltipTimeout.current = setTimeout(() => {
                setTooltipOpen(false);
                tooltipTimeout.current = undefined;
            }, 1000);
        });
    }
    function closePanel() {
        clearInput();
        dispatch(changeSidePanel_1.changeRightPanel(panels_1.RightPanelType.Participants));
    }
    function handleSelectUser(user) {
        closePanel();
        dispatch(addParticipants_1.default(chat, [user.userId]));
    }
    react_1.useLayoutEffect(() => {
        var _a;
        (_a = textBoxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    let mainContent;
    if (results.length) {
        mainContent = (react_1.default.createElement(List_1.default, { disablePadding: true }, results.map(user => react_1.default.createElement(UserListItem_1.default, { key: user.userId, user: users_1.fromUserSummary(user), handleSelectUser: () => handleSelectUser(user) }))));
    }
    else {
        mainContent = (react_1.default.createElement(Tooltip_1.default, { title: "copied!", placement: "bottom", open: tooltipOpen },
            react_1.default.createElement(Button_1.default, { onClick: handleCopyCodeButtonClick }, "Copy Invite Code")));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, { title: "Add participant", onCloseButtonClick: closePanel, rightIcon: react_1.default.createElement(CreateGroupChatIcon_1.default, { size: "sm" }), back: true }),
        react_1.default.createElement(SearchBox_1.default, { text: text, onChange: handleInputChange, placeholderText: PLACEHOLDER_TEXT, ref: textBoxRef }),
        mainContent));
}
